import { SxProps } from "@mui/material";

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px '
}

export const sxCheckbox: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#4C4C4C'
    } 
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px '
}

export const sxTermsOfUseModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '650px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '100vh',
    overflow: 'auto'
}